import { faArrowRightFromBracket, faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FC } from "react";
import keycloak from "../auth/keycloak";
import { PageHeader } from "../components/content/PageHeader";
import { Button } from "../components/form/Button";
import { Paragraph } from "../components/Paragraph";

export const ExpiredPage: FC = () => {
  return (
    <div>
      <PageHeader>
        <FontAwesomeIcon icon={faMinusCircle} className={"mr-3 text-red-800"} />
        Sessie verlopen
      </PageHeader>
      <Paragraph>Je sessie is verlopen. Log opnieuw in om verder te gaan.</Paragraph>
      <div className={"mt-8"}>
        <Button
          type={"primary"}
          size={"md"}
          text={"Uitloggen"}
          icon={faArrowRightFromBracket}
          onClick={() => keycloak.logout({ redirectUri: "https://app.dijkgraaf-support.nl" })}
        />
      </div>
    </div>
  );
};
